import { DatePickerView } from '@material-ui/pickers';
import { freqType } from '../../../hooks/useSip';
import {
    AmountType,
    defalutSipData,
    sipType,
    _schemeDetailsNewType,
} from '../../../redux-store/types/commercialTransactions';
import { DATE_VALUES, portfolioDetailsType } from './AdditionalPurchase/types';
import { getSipDays } from './ExploreMFs/mf-helpers';
import en from '../../../lang/en-us';

const {
    dbCommercial: { exploreMfs },
} = en;
type dayMappingType = {
    [key: string]: number;
};

const dayMappings: dayMappingType = {
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
};

export const calculateInstallment = (
    installment: number,
    sipDetails: sipType,
    currentScheme: any,
): number => {
    if (!!sipDetails) {
        let availableInstallments = sipDetails[
            currentScheme.frequency as string
        ]?.minimumInstallments
            .map((currentInstallment) => currentInstallment.installment)
            .map(Number)
            .sort((a: number, b: number) => a - b);
        return availableInstallments && availableInstallments.length > 0
            ? availableInstallments.reduce(
                  (acc: number, availableInstallment: number, index: number) => {
                      if (Math.trunc(Number(installment)) >= availableInstallment) return index;
                      return acc;
                  },
                  0,
              )
            : 0;
    }
    return 0;
};
const handleStringSip = (sipDays: Array<string>): number => {
    let splitStringArray: Array<string> = [];
    let sipAllowedDay = 0;
    sipDays.forEach((dayString: string) => {
        splitStringArray.push(...dayString.split(' '));
    });
    splitStringArray.forEach((sipDayString: string) => {
        let days = Object.keys(dayMappings);
        if (days.includes(sipDayString.toUpperCase())) {
            sipAllowedDay = dayMappings[sipDayString.toUpperCase()];
        }
    });
    return sipAllowedDay;
};
export const startDateDisable = (
    day: Date | null,
    sipDetails: sipType | null,
    currentScheme: any,
    startDate: Date,
    stpFlag: boolean,
    kfinFlag: boolean,
    amc?: string,
) => {
    if (!!day && !!sipDetails) {
        let sipDayList = sipDetails[currentScheme?.frequency || 0]?.dates || [];
        // let sipDayList = ['Every tuesday', 'Alternate tuesday'];
        //check if every entry in the sipday list is a string [ex: ['wednesday', 'friday'] not ['1', '2',..]]]
        //if so, allow only that day of the week

        let allStringFlag = sipDayList.every((sipDay: string) => isNaN(parseInt(sipDay)));
        if (allStringFlag) {
            let onlyAllowedSipDay = handleStringSip(sipDayList);
            if (!!onlyAllowedSipDay && day.getDay() !== onlyAllowedSipDay) {
                return true;
            }
        }
        //disable days past the start date
        // if (day.getTime() < startDate.getTime()) {
        //     return true;
        // }
        //current sip days
        let maxDateFlag = false,
            minDateFlag = false;
        // disable start date after maxSipTat days
        const maxDate = new Date();
        const minDate = new Date();
        let maxSipTat =
            sipDetails[currentScheme?.frequency || 0]?.maxSipTat || DATE_VALUES.startDateInterval;
        maxDate.setDate(maxDate.getDate() + parseInt(maxSipTat as string));
        let minSipTat = sipDetails[currentScheme?.frequency || 0]?.minSipTat || DEFAULT_MIN_TAT;
        minDate.setDate(minDate.getDate() + parseInt(minSipTat as string));
        if (day < minDate) minDateFlag = true;
        if (day > maxDate) maxDateFlag = true;
        //if frequency is weekly, enable monday date only.
        let mondayFlag = false;
        // if (currentScheme?.frequency === freqType.W) {
        //     if (day.getDay() !== 1) mondayFlag = true;
        // }
        // Disable weekends for Nippon (RMF) weekly STP
        if (amc === 'RMF' && currentScheme?.frequency === freqType.W) {
            if (day.getDay() === 0 || day.getDay() === 6) return true;
        }
        //enable the dates for only the days present in sip
        // if frequency is daily, disable saturday and sunday
        if (
            !stpFlag &&
            (currentScheme?.frequency === freqType.D || currentScheme?.frequency === freqType.DZ) &&
            kfinFlag
        ) {
            if (day.getDay() === 0 || day.getDay() === 6) return true;
        }
        let currentSipDays = getSipDays(sipDayList);
        return (
            !currentSipDays.includes(day?.getDate() || 1) ||
            maxDateFlag ||
            mondayFlag ||
            minDateFlag
        );
    }
    return false;
};

export const endDateDisable = (
    day: Date | null,
    sipDetails: sipType | null,
    currentScheme: any,
    startDate: Date,
    endDate: Date,
    stpFlag: boolean,
    kfinFlag: boolean,
    amc?: string,
) => {
    if (!!day && !!sipDetails) {
        let sipDayList = sipDetails[currentScheme?.frequency || 0]?.dates || [];
        // let sipDayList = ['Every wednesday', 'Alternate wednesday'];
        //check if every entry in the sipday list is a string [ex: ['wednesday', 'friday'] not ['1', '2',..]]]
        //if so, allow only that day of the week
        let allStringFlag = sipDayList.every((sipDay: string) => isNaN(parseInt(sipDay)));
        if (allStringFlag) {
            let onlyAllowedSipDay = handleStringSip(sipDayList);
            if (!!onlyAllowedSipDay && day.getDay() !== onlyAllowedSipDay) {
                return true;
            }
        }
        switch (currentScheme?.frequency) {
            case freqType.M:
                if (day.getDate() !== startDate.getDate()) return true;
                break;
            case freqType.W:
                // Disable weekends for Nippon (RMF)
                if (amc === 'RMF' && (day.getDay() === 0 || day.getDay() === 6)) return true;
                if (day.getDay() !== startDate.getDay()) return true;
                break;
            case freqType.D:
            case freqType.DZ:
                if ((!stpFlag && day.getDay() === 0) || (day.getDay() === 6 && kfinFlag))
                    return true;
                break;
            default:
        }
        let currentSipDays = getSipDays(sipDetails[currentScheme?.frequency || 0]?.dates || []);
        if (day.getFullYear() > 2099) return true;
        return !currentSipDays.includes(day?.getDate() || 1);
    } else return false;
};

export const handleCalendarView = (frequency: freqType): DatePickerView[] => {
    return [freqType.A].includes(frequency)
        ? ['year']
        : [freqType.H, freqType.Q, freqType.M].includes(frequency)
        ? ['month', 'year']
        : ['year', 'month', 'date'];
};

export const MAX_DATE = new Date('2099-12-31');

import * as yup from 'yup';
import { MAX_LENGTHS, MIN_LENGHTHS } from './Switch/types';
import { IsAllow, SCHEMES_RESPONSE } from '../../../redux-store/types/portfolio';
import {
    DEFAULT_MAX_INVESTMENT,
    DEFAULT_MIN_TAT,
    TRACK_STATUS_PATH,
} from '../../../utils/constants';
import { folioPurchaseEnum, PaymentTypes } from './ExploreMFs/types';
import { SwitchBy, Values } from './Switch/SwitchInvestment';
import { rtaNames, rtaType } from '../../common/FatcaCheck.types';

export const investModeValidationSchema = yup.object({
    distId: yup
        .string()
        .required(exploreMfs.errors.distId)
        .min(MIN_LENGHTHS.ARN_LENGTH, exploreMfs.errors.minLengthForArn),
    // subDist: yup
    //     .string()
    //     .required(exploreMfs.errors.subDist)
    //     .min(MIN_LENGHTHS.ARN_LENGTH, exploreMfs.errors.minLengthForArn),
    euin: yup
        .string()
        .required(exploreMfs.errors.EUINmandatory)
        .min(MAX_LENGTHS.EUIN_LENGTH, exploreMfs.errors.maxLengthForEuin),
    euinDeclarationFlag: yup.string().required(exploreMfs.errors.euinFlag),
    riaCode: yup.string().required(exploreMfs.errors.RIAMandatory),
});

export const formatRtaResponse = (data: any) => {
    const details: _schemeDetailsNewType = data.reduce((prev: any, curr: any, index: number) => {
        return index === 0 ? { ...prev, commonDetails: { ...curr } } : { ...prev, ...curr };
    }, {});
    return details;
};

export const isSipAllowed = (data: _schemeDetailsNewType['sip']) => {
    if (typeof data !== 'object') {
        return { bool: IsAllow.No, sip: defalutSipData };
    }
    const sip = Object.keys(data).reduce((prev: any, key) => {
        if (!Object.keys(data[key] as object).length) {
            return prev;
        }

        return {
            ...prev,
            [key]: {
                ...data[key],
                multiples:
                    !data[key]?.multiples || Number(data[key]?.multiples as any) < 1
                        ? 1
                        : data[key]?.multiples,
            },
        };
    }, {});
    return sip === null ? { bool: IsAllow.No, sip: defalutSipData } : { bool: IsAllow.YES, sip };
};

export const sortSip = (sip: any) => {
    if (!!sip && Object.keys(sip).length > 0) {
        Object.keys(sip).forEach((key) => {
            if (Object.keys(sip[key].minimumInstallments).length > 0) {
                sip[key].minimumInstallments = sip[key].minimumInstallments.sort(
                    (a: any, b: any) => a?.installment - b?.installment,
                );
            } else {
                throw new Error(en.dbCommercial.sip.errors.emptyInstallment);
            }
        });
    }
};

export const trackMyRequestPath = (id: string) => {
    return `${TRACK_STATUS_PATH}?tab=2`;
};

export const displayTransactionType = (type: string) => {
    return ['FSIP', 'ASIP'].includes(type) ? PaymentTypes.SIP : PaymentTypes.Lumpsum;
};

export const getFoliosFromAmc = (
    amcData: Array<portfolioDetailsType>,
    currentAmc: string,
    filters: Array<Function> = [],
) => {
    const _defaultValues = { folios: [], schemes: [] };
    if (!currentAmc) return _defaultValues;
    const filteredFolioSchemes = amcData
        .filter((amc: portfolioDetailsType) => {
            if (amc.summary['non_demat']?.amc === currentAmc) {
                return amc.schemes;
            }
        })[0]
        ?.schemes.reduce((acc: any, scheme: SCHEMES_RESPONSE) => {
            let valid = filters.every((filter) => filter.call({}, scheme));
            if (valid && scheme.folio && !acc.folios.includes(scheme.folio.toString())) {
                return {
                    folios: [...acc.folios, `${scheme.folio}`],
                    schemes: [...acc.schemes, scheme],
                };
            }
            return acc;
        }, _defaultValues);
    return filteredFolioSchemes;
};
export const shouldAllowDecimal = (value: string, redeemOrSwitchBy?: string) => {
    const decimalPartLength = value.split('.')[1]?.length;
    if (!!decimalPartLength && decimalPartLength > (redeemOrSwitchBy === SwitchBy.Amount ? 2 : 4))
        return false;
    return true;
};

export const isFatcaVerified = (fatcaStatusData: Array<rtaType>, rtaName: rtaNames) => {
    const rta_response = fatcaStatusData.find(
        (rta: any) => rta?.rtaName === rtaName,
    )?.fhFatcaStatus;
    if (rta_response === IsAllow.YES) {
        return true;
    }
    return false;
};

export const portfolioHasIsin = (portfolio: Array<portfolioDetailsType>, isin: string) => {
    let found = false;
    portfolio.forEach((item: portfolioDetailsType) => {
        item.schemes.forEach((scheme) => {
            if (scheme.isin === isin) found = true;
        });
    });
    return found;
};

export const isFolioNew = (portfolio: Array<portfolioDetailsType>, selectedFolio: string) => {
    let currentFolio: any = null;
    portfolio.forEach((item: portfolioDetailsType) => {
        item.schemes.forEach((scheme) => {
            if (String(scheme.folio) === String(selectedFolio)) {
                currentFolio = scheme;
            }
        });
    });
    if (!!currentFolio) {
        return currentFolio.newFolio === IsAllow.YES;
    }
    return false;
};

export const getValueForNewPurchase = (
    purchaseType: folioPurchaseEnum,
    isin: string,
    portfolioData: Array<portfolioDetailsType>,
    key: keyof AmountType,
    newPurchaseDetails: AmountType | null,
    addPurchaseDetails: AmountType | null,
    currentFolio: string,
) => {
    const folioNotNew = !isFolioNew(portfolioData, currentFolio);
    if (
        purchaseType == folioPurchaseEnum.EXISTING &&
        portfolioHasIsin(portfolioData, isin) &&
        folioNotNew
    ) {
        return !!addPurchaseDetails && addPurchaseDetails[key]
            ? addPurchaseDetails[key]
            : key === 'maxAmount'
            ? DEFAULT_MAX_INVESTMENT
            : 1;
    }
    return !!newPurchaseDetails && newPurchaseDetails[key]
        ? newPurchaseDetails[key]
        : key === 'maxAmount'
        ? DEFAULT_MAX_INVESTMENT
        : 1;
};
export const getValueForAddPurchase = (
    portfolioData: Array<portfolioDetailsType>,
    key: keyof AmountType,
    newPurchaseDetails: AmountType | null,
    addPurchaseDetails: AmountType | null,
    currentFolio: string,
) => {
    const folioNotNew = !isFolioNew(portfolioData, currentFolio);
    if (folioNotNew) {
        return !!addPurchaseDetails && addPurchaseDetails[key]
            ? addPurchaseDetails[key]
            : key === 'maxAmount'
            ? DEFAULT_MAX_INVESTMENT
            : 1;
    }
    return !!newPurchaseDetails && newPurchaseDetails[key]
        ? newPurchaseDetails[key]
        : key === 'maxAmount'
        ? DEFAULT_MAX_INVESTMENT
        : 1;
};

export function $wait(time: number) {
    return new Promise((res, rej) => {
        setTimeout(() => {
            res('over');
        }, time);
    });
}

export const TRXN_TYPE_MAP = {
    additionalPurchase: 'AP',
    additionalPurchaseSip: 'SIP',
    newPurchase: 'FP',
    redemption: 'R',
    switch: 'S',
    prospect: 'Prospect',
    stp: 'STP',
    swp: 'SWP',
    sipPause: 'SIPP',
    sipCancel: 'SIPC',
} as const;

export const NFT_TRXN_TYPE_MAP = {
    changeOfIdcw: 'COD',
    unregisteredFolios: 'COC',
    changeEmail: 'COC',
    changeMobile: 'COC',
    consolidationOfFolios: 'COFI',
    correctionOfErroneousData: 'DE',
    changeBankDetails: 'COB',
    multipleBankMandate: 'MBMR',
    updateNomineeDetails: 'NOM',
    updateBankIFSC: 'COI',
    changeOfTaxStatus: 'COT',
    transmissionRequest: 'TRR',
    fatcaCrsDeclaration: 'FAT',
    minorToMajor: 'MAM',
    updateForm15: 'F15GH',
    updatePan: 'CPAN',
} as const;

export type NFT_TRXN_MAP_TYPE = typeof NFT_TRXN_TYPE_MAP;
export type NFT_TRXN_MAP_TYPE_KEYS = keyof NFT_TRXN_MAP_TYPE;
export type NFT_TRXN_MAP_TYPE_VALUES = NFT_TRXN_MAP_TYPE[NFT_TRXN_MAP_TYPE_KEYS];

export type TRXN_MAP_TYPE = typeof TRXN_TYPE_MAP;
export type TRXN_MAP_TYPE_KEYS = keyof TRXN_MAP_TYPE;
export type TRXN_MAP_TYPE_VALUES = TRXN_MAP_TYPE[TRXN_MAP_TYPE_KEYS];
